import type { LucideIcon } from 'lucide-react';
import { Trophy } from 'lucide-react';
import { BrowserImage } from '@/components/ui/BrowserImage';
import { playEventDisplayTheme } from './playEventDisplayTheme';

interface PlayEventDisplayBrandMarkProps {
  logoUrl?: string | null;
  organizationName?: string | null;
  fallbackIcon?: LucideIcon;
}

export function PlayEventDisplayBrandMark({
  logoUrl,
  organizationName,
  fallbackIcon: FallbackIcon = Trophy,
}: PlayEventDisplayBrandMarkProps) {
  if (logoUrl) {
    return (
      <div className={playEventDisplayTheme.accentIconWrap}>
        <BrowserImage
          src={logoUrl}
          alt={organizationName ? `${organizationName} logo` : 'Organization logo'}
          className="h-full w-full object-contain"
          referrerPolicy="no-referrer"
          fallback={
            <FallbackIcon className={playEventDisplayTheme.accentIcon} aria-hidden />
          }
        />
      </div>
    );
  }

  return (
    <div className={playEventDisplayTheme.accentIconWrap}>
      <FallbackIcon className={playEventDisplayTheme.accentIcon} aria-hidden />
    </div>
  );
}
